import Vue from "vue";
import Router from "vue-router";
import { routes } from "./routes";
import store from "@/store/index.js";

const routerPush = Router.prototype.push;
const routerReplace = Router.prototype.replace;
Router.prototype.push = function push (location) {
    return routerPush.call(this, location).catch((error) => error);
};
Router.prototype.replace = function replace (location) {
    return routerReplace.call(this, location).catch((error) => error);
};

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: routes
});
router.beforeEach((to, from, next) => {
    const authToken = store.getters.authToken;
    if (to.name === "login") {
        next();
    } else if (to.name.indexOf("error") > -1) {
        next();
    } else {
        if (to.meta.nologin) {
            next();
        } else if (authToken) {
            let permissionList = store.getters.permissionList;
            let hasPermission = false;
            permissionList.forEach(item => {
                if (item.url === to.path ||
                    (to.meta && to.meta.permissionRely && item.url === to.meta.permissionRely) ||
                    to.meta.nopermission
                ) {
                    store.commit("updateActiveMenu", item);
                    hasPermission = true;
                    return false;
                }
            });
            if (!hasPermission) {
                Vue.prototype.$Message.warning("该页面您没有访问权限");
                next({
                    name: "error403"
                });
            } else {
                // 调用接口判断token当前状态
                Vue.prototype.$post({
                    url: "/api/user/checkUserToken",
                    data: {},
                    callback: (data) => {
                        next();
                    }
                });
            }
        } else {
            next({
                name: "login"
            });
        }
    }
});
router.afterEach((to, from) => {
    if (to.path.indexOf("/admin/") > -1) {
        // 获取未读信息个数，超过100提示99+，所以只获取100条就行
        Vue.prototype.$post({
            url: "/api/notice/list",
            data: {
                page: 1,
                pageSize: 100,
                read: false
            },
            callback: (data) => {
                store.commit("updateNotice", data.count);
            }
        });
    }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js